import React from 'react';
import './Contact.css';
import contactData from '../data/contact.json';
import { useContent } from '../contexts/ContentContext';

const Contact = () => {
  const { getSection } = useContent();
  const data = getSection<typeof contactData>('contact', contactData);
  const { contact } = data;

  const normalizeUrl = (url: string) => {
    if (!url) {
      return '#';
    }
    const trimmed = url.trim();
    if (trimmed.startsWith('https://https://')) {
      return trimmed.replace('https://https://', 'https://');
    }
    if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('#')) {
      return trimmed;
    }
    return `https://${trimmed}`;
  };

  const getSocialIcon = (platform: string) => {
    const icons = {
      instagram: <i className="fab fa-instagram"></i>,
      linkedin: <i className="fab fa-linkedin-in"></i>,
      github: <i className="fab fa-github"></i>,
      twitter: <i className="fab fa-twitter"></i>,
      discord: <i className="fab fa-discord"></i>,
      facebook: <i className="fab fa-facebook-f"></i>
    };
    return icons[platform] || <i className="fas fa-link"></i>;
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <div className="section-header">
          <h2 className="section-title">{contact.title}</h2>
          <p className="section-subtitle">{contact.description}</p>
        </div>

        <div className="contact-content">
          <div className="contact-card">
            <div className="contact-card__header">
              <p className="contact-card__eyebrow">Get In Touch</p>
              <h3>Let&apos;s Build Something Together</h3>
            </div>

            <div className="contact-details">
              <div className="contact-item">
                <div className="contact-icon">📧</div>
                <div>
                  <h4>Email</h4>
                  <p>{contact.email}</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <div>
                  <h4>Address</h4>
                  <p>{contact.address}</p>
                </div>
              </div>
            </div>

            <div className="contact-card__actions">
              <a href={`mailto:${contact.email}`} className="contact-action contact-action--primary">
                Send Email
              </a>
              <a
                href={normalizeUrl(contact.college.website)}
                target="_blank"
                rel="noopener noreferrer"
                className="contact-action contact-action--ghost"
              >
                Visit College Website
              </a>
            </div>
          </div>

          <div className="social-section">
            <h3>Follow Us</h3>
            <div className="social-links">
              {contact.socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={normalizeUrl(social.url)}
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="social-icon">{getSocialIcon(social.icon)}</span>
                  <span className="social-name">{social.platform}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="bg-grace">
        <div className="wave wave-1"></div>
        <div className="wave wave-2"></div>
        <div className="wave wave-3"></div>
      </div>
    </section>
  );
};

export default Contact;